import '../exports/app';
import {App3DConfig} from '../app3D/App3D';

export class I18n{
	constructor(
		protected config: App3DConfig) {}

	setLang(lang){
		$.get(this.config.app_root + 'rest/i18n/' + i18n_domains + '/' + lang, function (dict) {
			$('.i18n').each(function () {
				let e = $(this);
				let k = e.data('i18n');
				if (k && dict.hasOwnProperty(k)){
					let args:string[] = e.data('i18n-args');
					let translation = dict[k];
					if (args){
						if (args.length)
							translation = translation.replace(/\$(\d+|\$)/g, function (m, c, i) {
								if (m[1] === '$')
									return '$';
								return args[Number(c) - 1];
							});
					}
					e.text(translation);
				}
			});
		}, 'json');
	}
}



// WEBPACK FOOTER //
// ./src/script/app/I18n.ts